import { CartItemBase } from 'core/domains';
import { app, cart, utilities } from 'core/use-cases';
import { put } from 'core/middlewares/utilities';
import { cart as cartSelectors } from 'core/middlewares/effects/helpers';

import { messages } from './event-messages';

export function* setLoading(action: utilities.ActionSuccess<keyof typeof messages.request>) {
  const { payload, type } = action;

  if (type === cart.actions.itemUpdateFetch.request.type) {
    const { productCode, quantity } = payload as CartItemBase;
    const cartItems: cartSelectors.CartItems = yield cartSelectors.getCartItems();
    const updatedItem = cartItems.find((item) => item.productCode === productCode);

    if (updatedItem && quantity > updatedItem.previousQuantity) {
      yield put(app.actions.setLoading(messages.request[cart.actions.itemAddFetch.request.type]));

      return;
    }

    yield put(app.actions.setLoading(messages.request[cart.actions.itemDeleteFetch.request.type]));

    return;
  }

  yield put(app.actions.setLoading(messages.request[type]));
}
